export const styleObject = {
  singleValue: (styles: any) => ({
  ...styles,
  fontSize: 16,
  }),
  container: (provided: any) => ({
    ...provided,
    boxShadow: "none", // Remove the box shadow from the container
  }),
  control: (styles: any, state: any) => ({
    ...styles,
    border: "none",
    borderBottom: "1px solid rgba(165, 173, 189, 0.3)",
    borderRadius: 0,
    boxShadow: "none",
    color: "#22272a",
    fontSize: 16,
    fontFamily: "SourceSansPro-Regular",
    cursor: "pointer",
    minHeight: "32px",
    order: 0,
    paddingBottom: "8px",
    "@media (min-width: 768px)": {
      ...styles["media (max-width: 768px)"],
      fontSize: 22,
    },
    backgroundColor: state.isDisabled ? "white" : "white",
    ":hover": {
      ...styles[":hover"],
      borderBottom: "1px solid rgba(165, 173, 189, 0.3)",
    },
    ":focus": {
      ...styles[":focus"],
      borderBottom: "1px solid rgba(165, 173, 189, 0.3)",
    },
    ":active": {
      ...styles[":active"],
      borderBottom: "1px solid rgba(165, 173, 189, 0.3)",
    },
  }),
  valueContainer: (styles: any) => ({
    ...styles,
  fontSize: 16,
    padding: "2px 24px 2px 8px",
    flexDirection: "row-reverse",
    "@media (min-width: 768px)": {
      ...styles["media (max-width: 768px)"],
      fontSize: 22,
      padding: "2px 32px 2px 8px",
    },
  }),
  multiValue: (styles: any) => ({
    ...styles,
    backgroundColor: "#a5adbd",
    color: "white",
    borderRadius: "4px",
    fontSize: "16px",
  }),
  multiValueLabel: (styles: any) => ({
    ...styles,
    color: "white",
    fontSize: "16px",
  }),
  input: (styles: any) => ({
    ...styles,
    fontSize: 16,
  }),
  placeholder: (styles: any) => ({
    ...styles,
    fontSize: 20,
  }),
  indicatorsContainer: (styles: any) => ({
    ...styles,
    ">div": {
      ...styles[">div"],
      padding: "0",
    },
    order: -1,
  }),
  indicatorSeparator: (styles: any) => ({
    ...styles,
    color: "black",
    display: "none",
  }),
  clearIndicator: (styles: any) => ({
    ...styles,
    color: "black",
    order: 2,
    position: "absolute",
    right: 0,
    width: "16px",
    height: "16px",
    "@media (min-width: 768px)": {
      ...styles["media (max-width: 768px)"],
      width: "24px",
      height: "24px",
    },
  }),
  dropdownIndicator: (styles: any, state: any) => ({
    ...styles,
    order: -1,
    width: "32px",
    height: "32px",
    "@media (min-width: 768px)": {
      ...styles["media (max-width: 768px)"],
      width: "40px",
      height: "40px",
    },
    filter: state.isDisabled
      ? "brightness(0) saturate(100%) invert(63%) sepia(2%) saturate(1592%) hue-rotate(177deg) brightness(111%) contrast(87%)"
      : "none",
  }),
  menu: (styles: any) => ({
    ...styles,
    fontSize: 16,
    fontFamily: "SourceSansPro-light",
    backgroundColor: "white",
    padding: "6px 8px",
    border: "none",
    borderRadius: "8px",
    borderTopRightRadius: "0",
    borderTopLeftRadius: "0",
    boxShadow: "0 2px 15px #a5adbd",
    marginTop: "-1px",
    color: "#22272a",
    "@media (min-width: 768px)": {
      ...styles["media (max-width: 768px)"],
      fontSize: 16,
    },
  }),
  menuList: (provided: any) => ({
    ...provided,
    maxHeight: "200px", // Set a maximum height
    overflowY: "auto", // Enable vertical scrolling
  }),
  option: (styles: any, state: any) => ({
    ...styles,
    fontSize: 16,
    fontFamily: "SourceSansPro-Light",
    cursor: "pointer",
    height: "38px",
    borderBottom: "1px solid rgba(165, 173, 189, 0.3)",
    ":hover": {
      ...styles[":hover"],
      backgroundColor: "#f5f6fa",
    },
    ":active": {
      ...styles[":active"],
      backgroundColor: "#f5f6fa",
    },
    ":focus": {
      ...styles[":focus"],
      backgroundColor: "#f5f6fa",
    },
    backgroundColor: state.isSelected || state.isFocus ? "#f5f6fa" : "white",
    color: "#22272a",
  }),
};